import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import BuildEnvBanner from '@/components/BuildEnvBanner'
import Layout from '@/components/Layout'
import Landing from '@/pages/landing/Landing'
import Login from '@/pages/auth/Login'
import Main from '@/pages/main/Main'
import Dashboard from '@/pages/dashboard/Dashboard'
import MemberDashboard from '@/pages/dashboard/MemberDashboard'
import AccumulationHistory from '@/pages/dashboard/AccumulationHistory'
import CouponHistory from '@/pages/dashboard/CouponHistory'

function App() {
  return (
    <>
      <BuildEnvBanner />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/main" element={<Layout><Main /></Layout>} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/member" element={<MemberDashboard />} />
        <Route path="/dashboard/member/accumulation-history" element={<AccumulationHistory />} />
        <Route path="/dashboard/member/coupon-history" element={<CouponHistory />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default App
